import {
  CONTENTCATEGORY_LOADING,
  GET_CONTENTCATEGORY,
  GET_CONTENTCATEGORY_SUCCESS,
  GET_CONTENTCATEGORY_FAIL,
  ADD_CONTENTCATEGORY_SUCCESS,
  ADD_CONTENTCATEGORY_FAIL,
  DELETE_CONTENTCATEGORY_SUCCESS,
  DELETE_CONTENTCATEGORY_FAIL,
  UPDATE_CONTENTCATEGORY_SUCCESS,
  UPDATE_CONTENTCATEGORY_FAIL,
  CONTENTCATEGORY_RESET
} from "./actionType";

const INIT_STATE = {
  contentCategories: [],
  error: {},
};

const ContentCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CONTENTCATEGORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CONTENTCATEGORY:
          return {
            ...state,
            contentCategories: action.payload.data,
            isContentCategoryCreated: false,
            isContentCategorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CONTENTCATEGORY_FAIL:
      switch (action.payload.actionType) {
        case GET_CONTENTCATEGORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isContentCategoryCreated: false,
            isContentCategorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CONTENTCATEGORY: {
      return {
        ...state,
        isContentCategoryCreated: false,
        loading: true,
      };
    }

    case CONTENTCATEGORY_LOADING: {
      return {
        ...state,
        isContentCategoryCreated: false,
        loading: true,
      };
    }

    case ADD_CONTENTCATEGORY_SUCCESS:
      return {
        ...state,
        isContentCategoryCreated: true,
        loading: false,
        contentCategories: [action.payload.data, ...state.contentCategories],
      };

    case ADD_CONTENTCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CONTENTCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        contentCategories: state.contentCategories.filter(
          contentCategory => contentCategory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CONTENTCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CONTENTCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        contentCategories: state.contentCategories.map(contentCategory =>
          contentCategory.id.toString() === action.payload.data.id.toString() ? { ...contentCategory, ...action.payload.data } : contentCategory
        ),
      };

    case UPDATE_CONTENTCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CONTENTCATEGORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ContentCategory;